import { FC } from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

interface AIIconProps extends Omit<SvgIconProps, "color"> {
  color?: string;
}

export const AIIcon: FC<AIIconProps> = ({ color = "gradient", ...props }) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="23"
        viewBox="0 0 20 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7249 0.500492C16.0446 1.47076 16.356 2.33771 17.1709 3.00292C17.5723 3.33074 17.9739 3.47376 18.4049 3.62725C18.5678 3.68524 18.7349 3.74473 18.9077 3.81624C18.921 3.82174 18.9376 3.82703 18.9555 3.83273C19.0273 3.85556 19.1198 3.885 19.1056 3.96139C19.1133 4.03371 19.0699 4.05099 19.0237 4.06943C19.0107 4.07458 18.9976 4.07981 18.9853 4.08636C18.7993 4.18486 18.5879 4.25459 18.3712 4.32605C18.1397 4.40238 17.9023 4.48067 17.6837 4.59807C16.9744 4.97889 16.4685 5.56342 16.1433 6.29456C16.1032 6.38469 16.0464 6.55994 15.9866 6.74419C15.8992 7.0136 15.8055 7.30226 15.7489 7.3721C15.7057 7.42523 15.6694 7.43606 15.6031 7.42277C15.5652 7.41499 15.4221 7.00511 15.31 6.6839C15.252 6.51779 15.2023 6.37539 15.1797 6.32458C14.7735 5.41187 14.1418 4.79783 13.2263 4.40372C13.0993 4.3491 12.9506 4.30416 12.8019 4.25922C12.6292 4.207 12.4564 4.15478 12.3176 4.08735C12.156 4.00862 12.127 3.94417 12.297 3.86593C12.4855 3.77937 12.6827 3.71223 12.8802 3.64499C13.126 3.56127 13.3723 3.4774 13.603 3.35571C14.741 2.75593 15.2347 1.68479 15.5785 0.5L15.7249 0.500492Z"
          fill={
            color !== "gradient" ? color : "url(#paint0_linear_20315_24039)"
          }
        />
        <path
          d="M14.4876 11.3629C14.5549 11.447 14.5554 11.5784 14.4655 11.6477C14.1228 11.7961 13.767 11.9159 13.4114 12.0358C13.0687 12.1512 12.7261 12.2667 12.3957 12.4074C10.5356 13.1996 9.29782 14.531 8.5365 16.3948C8.45123 16.6036 8.36865 16.8715 8.28412 17.1457C8.15831 17.5537 8.02816 17.9759 7.87833 18.2384C7.841 18.3043 7.79139 18.3432 7.71575 18.3535L7.50651 18.1882C6.7334 15.4536 5.55704 13.4618 2.8546 12.3445C2.62132 12.248 2.34745 12.1619 2.07123 12.0751C1.69085 11.9555 1.30601 11.8345 1.01663 11.6832C0.944424 11.6453 0.889904 11.6099 0.881063 11.5198C0.87566 11.4598 0.890886 11.417 0.928216 11.3702C0.97933 11.3061 1.67969 11.0637 2.23047 10.8731C2.51592 10.7743 2.7612 10.6894 2.85509 10.6504C5.55802 9.53352 6.73439 7.54132 7.507 4.80665L7.71624 4.64133C7.79188 4.65166 7.84149 4.69053 7.87882 4.75646C8.02865 5.01897 8.1588 5.44112 8.28461 5.84922C8.36915 6.12342 8.45172 6.39127 8.537 6.60008C9.10823 7.99841 9.96435 9.15466 11.2424 9.97634C11.9613 10.4384 12.7299 10.715 13.5102 10.9958C13.835 11.1127 14.1614 11.2308 14.4876 11.3629Z"
          fill={
            color !== "gradient" ? color : "url(#paint1_linear_20315_24039)"
          }
        />
        <path
          d="M18.404 19.3695C18.7403 19.2538 19.0812 19.1366 19.1028 19.1039C19.1312 19.0601 19.1052 18.9789 19.0536 18.9366C18.9721 18.8698 18.6814 18.7768 18.4125 18.6908C18.2376 18.6349 18.0719 18.5819 17.9789 18.541C17.1218 18.1631 16.5226 17.556 16.142 16.6999C16.0749 16.549 16.022 16.3823 15.9694 16.2167C15.911 16.0328 15.853 15.8501 15.7765 15.6917C15.771 15.6805 15.7664 15.669 15.7618 15.6577C15.7421 15.6091 15.7241 15.5645 15.6508 15.5716C15.5801 15.5605 15.5752 15.5837 15.5677 15.6189C15.5646 15.6336 15.561 15.6503 15.5521 15.6676C15.4716 15.8219 15.4134 16.0056 15.3554 16.1887C15.3101 16.3318 15.2648 16.4746 15.2092 16.6024C14.7976 17.5506 14.1753 18.1818 13.2254 18.5907C13.0984 18.6453 12.9497 18.6903 12.801 18.7352C12.6283 18.7874 12.4555 18.8396 12.3167 18.9071C12.1551 18.9858 12.1261 19.0503 12.2961 19.1285C12.5381 19.2395 12.7663 19.3316 12.9821 19.4187C13.8474 19.768 14.513 20.0367 15.0653 21.1172C15.1073 21.1993 15.1927 21.442 15.284 21.7013C15.4159 22.0761 15.56 22.4854 15.6026 22.4944C15.669 22.5087 15.7048 22.4969 15.748 22.4442C15.7981 22.3829 15.8822 22.1122 15.9595 21.8636C16.0111 21.6975 16.0596 21.5414 16.0928 21.4641C16.4234 20.6956 17.0054 19.9821 17.7638 19.6038C17.854 19.5587 18.1274 19.4647 18.404 19.3695Z"
          fill={
            color !== "gradient" ? color : "url(#paint2_linear_20315_24039)"
          }
        />
        <defs>
          <linearGradient
            id="paint0_linear_20315_24039"
            x1="0.880005"
            y1="0.5"
            x2="21.38"
            y2="22.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1443EA" />
            <stop offset="1" stop-color="#7334F1" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_20315_24039"
            x1="0.880005"
            y1="0.5"
            x2="21.38"
            y2="22.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1443EA" />
            <stop offset="1" stop-color="#7334F1" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_20315_24039"
            x1="0.880005"
            y1="0.5"
            x2="21.38"
            y2="22.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1443EA" />
            <stop offset="1" stop-color="#7334F1" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};
